/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TriggerProvenanceDto } from './TriggerProvenanceDto';
import {
    TriggerProvenanceDtoFromJSON,
    TriggerProvenanceDtoFromJSONTyped,
    TriggerProvenanceDtoToJSON,
    TriggerProvenanceDtoToJSONTyped,
} from './TriggerProvenanceDto';

/**
 * 
 * @export
 * @interface TriggerEventEnvelope
 */
export interface TriggerEventEnvelope {
    /**
     * 
     * @type {string}
     * @memberof TriggerEventEnvelope
     */
    eventId?: string;
    /**
     * 
     * @type {Date}
     * @memberof TriggerEventEnvelope
     */
    occurredAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof TriggerEventEnvelope
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerEventEnvelope
     */
    instanceTenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerEventEnvelope
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerEventEnvelope
     */
    entityId?: string;
    /**
     * 
     * @type {string}
     * @memberof TriggerEventEnvelope
     */
    changeType?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TriggerEventEnvelope
     */
    changedFields?: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TriggerEventEnvelope
     */
    oldValues?: { [key: string]: any; };
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof TriggerEventEnvelope
     */
    newValues?: { [key: string]: any; };
    /**
     * 
     * @type {TriggerProvenanceDto}
     * @memberof TriggerEventEnvelope
     */
    provenance?: TriggerProvenanceDto;
}

/**
 * Check if a given object implements the TriggerEventEnvelope interface.
 */
export function instanceOfTriggerEventEnvelope(value: object): value is TriggerEventEnvelope {
    return true;
}

export function TriggerEventEnvelopeFromJSON(json: any): TriggerEventEnvelope {
    return TriggerEventEnvelopeFromJSONTyped(json, false);
}

export function TriggerEventEnvelopeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TriggerEventEnvelope {
    if (json == null) {
        return json;
    }
    return {
        
        'eventId': json['eventId'] == null ? undefined : json['eventId'],
        'occurredAt': json['occurredAt'] == null ? undefined : (new Date(json['occurredAt'])),
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'instanceTenantId': json['instanceTenantId'] == null ? undefined : json['instanceTenantId'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'entityId': json['entityId'] == null ? undefined : json['entityId'],
        'changeType': json['changeType'] == null ? undefined : json['changeType'],
        'changedFields': json['changedFields'] == null ? undefined : json['changedFields'],
        'oldValues': json['oldValues'] == null ? undefined : json['oldValues'],
        'newValues': json['newValues'] == null ? undefined : json['newValues'],
        'provenance': json['provenance'] == null ? undefined : TriggerProvenanceDtoFromJSON(json['provenance']),
    };
}

export function TriggerEventEnvelopeToJSON(json: any): TriggerEventEnvelope {
    return TriggerEventEnvelopeToJSONTyped(json, false);
}

export function TriggerEventEnvelopeToJSONTyped(value?: TriggerEventEnvelope | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eventId': value['eventId'],
        'occurredAt': value['occurredAt'] == null ? undefined : ((value['occurredAt']).toISOString()),
        'tenantId': value['tenantId'],
        'instanceTenantId': value['instanceTenantId'],
        'entityType': value['entityType'],
        'entityId': value['entityId'],
        'changeType': value['changeType'],
        'changedFields': value['changedFields'],
        'oldValues': value['oldValues'],
        'newValues': value['newValues'],
        'provenance': TriggerProvenanceDtoToJSON(value['provenance']),
    };
}

